/**
 * Human-readable relative time for post timestamps ("2 hrs ago", "Last week").
 * @param {string|number|Date|null|undefined} dateInput ISO string or comparable
 * @param {number} [nowMs=Date.now()] clock for testing
 * @returns {string}
 */
export function formatRelativeTime(dateInput, nowMs = Date.now()) {
  if (dateInput == null || dateInput === '') return '';
  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  const t = d.getTime();
  if (Number.isNaN(t)) return '';

  let sec = Math.floor((nowMs - t) / 1000);
  if (sec < 0) sec = 0;
  if (sec < 60) return 'Just now';

  const min = Math.floor(sec / 60);
  if (min < 60) return min === 1 ? '1 minute ago' : `${min} minutes ago`;

  const hr = Math.floor(min / 60);
  if (hr < 24) return hr === 1 ? '1 hr ago' : `${hr} hrs ago`;

  const day = Math.floor(hr / 24);
  if (day === 1) return 'Yesterday';
  if (day < 7) return `${day} days ago`;
  if (day < 14) return 'Last week';

  if (day < 30) {
    const weekCount = Math.floor(day / 7);
    if (weekCount === 2) return '2 weeks ago';
    if (weekCount < 5) return `${weekCount} weeks ago`;
  }

  const mo = Math.floor(day / 30);
  if (mo < 12) return mo <= 1 ? 'Last month' : `${mo} months ago`;

  const yr = Math.floor(day / 365);
  return yr <= 1 ? 'Last year' : `${yr} years ago`;
}
